// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "voice_receptionist_setting".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "voice_receptionist_setting" table (1:1 with a DB row, on the wire). */
export const voiceReceptionistSettingAtomSchema = z.object({
    organizationId: z.string(),
    enabled: z.boolean(),
    handoffNumber: z.string().nullable(),
    voiceId: z.string().nullable(),
    recordCalls: z.boolean(),
    dedicatedPhoneNumberId: z.string().nullable(),
    sharedPhoneNumberId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=voiceReceptionistSetting.js.map